// import env from "../env"

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import customLodash from './../libs/customLodash'
const sortBy = customLodash.sortBy
const keyBy = customLodash.keyBy
dayjs.extend(relativeTime)

// const TWOHOURSSEC = 120 * 60

function SortArrayByName(x, y) {
	return x.name.localeCompare(y.name, 'de', { ignorePunctuation: true })
}

const getters: any = {
	projectsObj: (s: any) => keyBy(s.projects, '_id'),
	//! locs
	locationsObj: (s: any) => keyBy(s.locations, '_id'),
	inventoryObj: (s: any) => keyBy(s.inventoryList, '_id'),
	locationsByPId: (s: any) => {
		const result: any = {}
		const statelocations = sortBy(s.locations, 'name')
		for (const l of statelocations) {
			if (!result[l.projectId]) result[l.projectId] = []
			result[l.projectId].push(l)
		}
		return result
	},
	//! hubs
	hubsObj: (s: any) => keyBy(s.hubs, '_id'),
	hubsByLId: (s: any) => {
		const result: any = {}
		for (const h of s.hubs) {
			if (!result[h.locationId]) result[h.locationId] = []
			result[h.locationId].push(h)
		}
		return result
	},
	hubsSerial: (s: any) => keyBy(s.hubs, 'serial'),
	//! modules
	modulesObj: (s: any) => keyBy(s.modules, '_id'),
	modulesSerial: (s: any) => keyBy(s.modules, 'serial'),

	modulesByHubSerial: (s: any) => {
		const result: any = {}
		for (const m of s.modules) {
			if (!result[m.currentHub]) result[m.currentHub] = []
			result[m.currentHub].push(m)
		}
		return result
	},

	customGraphsObj: (s: any) => keyBy(s.customGraphs, '_id'),
	customGraphsSerial: (s: any) => keyBy(s.customGraphs, 'serial'),
	customGraphsByHubs: (s: any) => {
		// keyBy(s.customGraphs, "hubSerial"}
		const result: any = {}
		for (const cg of s.customGraphs) {
			const hKey = cg.hubSerial || 'general'
			if (!result[hKey]) result[hKey] = []
			result[hKey].push(cg)
		}
		return result
	},

	// hubsByLocLastOnline: (s: any) => {
	// 	// const now: number = Date.now()
	// 	const result: any = {}
	// 	for (const hub of s.hubs) {
	// 		const locId = hub.locationId || 'NO_LOCATION'
	// 		// const hubTime = dayjs(hub.modified).unix() * 1000
	// 		// const hubTime = (dayjs(hub.lastLog).unix() - TWOHOURSSEC) * 1000
	// 		const hubTime = dayjs(hub.lastLog).unix() * 1000
	// 		const diff = dayjs(hubTime).fromNow()
	// 		// console.log(diff, hubTime, now, hub.lastLog);

	// 		if (!result[locId]) result[locId] = { modified: 0 }
	// 		if (result[locId].modified < hubTime) {
	// 			result[locId] = {
	// 				modified: hubTime,
	// 				diff,
	// 				// logOffsetHours: hub.logOffsetHours
	// 			}
	// 		}
	// 	}
	// 	return result
	// },
	hubsByLoc: (s: any) => {
		// const now: number = Date.now()
		const result: any = {}
		for (const hub of s.hubs) {
			const locId = hub.locationId || 'NO_LOCATION'
			// const hubTime = (dayjs(hub.lastLog).unix() - TWOHOURSSEC) * 1000
			const hubTime = dayjs(hub.lastLog).unix() * 1000
			const diff = dayjs(hubTime).fromNow()
			// console.log(hubTime,now);
			if (!result[locId]) result[locId] = []
			result[locId].push({
				serial: hub.serial,
				modified: hubTime,
				diff,
				// logOffsetHours: hub.logOffsetHours
				// diff: dayjs(hubTime)
			})
		}
		return result
	},

	shownModulesByHub: (s: any) => {
		const result: any = {}
		s.hubs.forEach((hel: any) => {
			result[hel.serial] = s.modules.filter((el: any) => el.show && el.currentHub === hel.serial)
		})
		return result
	},

	shownModulesByLocId: (s: any, g: any) => {
		const result: any = {}
		const projectIdCalculated = s.projectIdCalculated
		const locations: any = sortBy(s.locations, 'name')
		const hubsByLoc: any = g.hubsByLoc
		const shownModulesByHub: any = g.shownModulesByHub
		for (const locIdx in locations) {
			if (projectIdCalculated === '' || locations[locIdx].projectId === projectIdCalculated) {
				const locId = locations[locIdx]._id
				result[locId] = []
				for (const hIdx in hubsByLoc[locId]) {
					const hubSerial = hubsByLoc[locId][hIdx].serial
					for (const m of shownModulesByHub[hubSerial]) {
						result[locId].push(m)
					}
				}
			}
		}
		return result
	},

	customGraphsByLocId: (s: any) => {
		const result: any = {}
		for (const cg of s.customGraphs) {
			const locId = cg.locationId || 'general'
			if (!result[locId]) result[locId] = []
			result[locId].push(cg)
		}
		for (const pid in result) {
			result[pid] = result[pid].sort(SortArrayByName)
		}
		return result
	},

	customGraphsByProjectId: (s: any) => {
		const result: any = {}
		for (const cg of s.customGraphs) {
			const projectId = cg.projectId || 'general'
			if (!result[projectId]) result[projectId] = []
			result[projectId].push(cg)
		}
		for (const pid in result) {
			result[pid] = result[pid].sort(SortArrayByName)
		}
		return result
	},

	commappObj: (s: any) => keyBy(s.comapps.data, '_id'),
	commappByPcName: (s: any) => keyBy(s.comapps.data, 'pcName'),
	comappsByProject: (s: any) => {
		const result: any = {}
		result.data = s.comapps.data.filter((comapp: any) => comapp.projectId === s.projectIdRoute)
		result.storage = result.data.map((comapp: any) => comapp.pcName.replace('ComApp__', ''))
		return result
	},

	comappsByLId: (s: any) => {
		const result: any = {}
		for (const c of s.comapps.data) {
			if (c.locationId) {
				if (!result[c.locationId]) result[c.locationId] = []
				result[c.locationId].push(c)
			}
		}
		return result
	},

	sensorAlerts: (s: any, g: any) => {
		try {
			const result: any = {}
			const alerts = s.alerts || {}
			const warns = s.warns || {}
			const customGraphsObj = g.customGraphsObj || {}
			// console.log('customGraphsObj', customGraphsObj)
			for (const cgId in alerts) {
				// console.log('customGraphsObj?.[ cgId ]',customGraphsObj?.[ cgId ])
				for (const eq of customGraphsObj?.[cgId]?.equations || []) {
					const skey = `-/-/${eq.name}`
					const isAlert = !!alerts[cgId]?.data?.[skey]
					const isWarn = !!warns[cgId]?.data?.[skey]
					const alertDate = alerts[cgId]?.alertDates?.[skey]
					const warnDate = warns[cgId]?.warnDates?.[skey]
					result[`${cgId}//${eq.name}`] = {
						cgName: customGraphsObj[cgId].name,
						name: eq.name,
						alert: isAlert,
						warn: isWarn,
						cgId: cgId,
						locationId: customGraphsObj[cgId].locationId,
						lastAlertDate: alertDate,
						lastWarnDate: warnDate,
					}
				}
			}
			return result
		} catch (error: any) {
			console.log(error)
			return {}
		}
	},
	sensorAlertsDates: (s: any, g: any) => {
		try {
			let sensorAlerts = Object.values(g.sensorAlerts || {})
			const yesterday = Date.now() - 1000 * 60 * 60 * 24 * 3
			sensorAlerts = sensorAlerts.filter((el: any) => {
				let isInTimeRangeWarn = el.lastWarnDate > yesterday
				const isInTimeRangeAlert = el.lastAlertDate > yesterday
				if (isInTimeRangeAlert) {
					isInTimeRangeWarn = false
					el.wasAlert = true
					el.wasWarn = false
				} else if (isInTimeRangeWarn) {
					el.wasAlert = false
					el.wasWarn = true
				}
				return isInTimeRangeWarn || isInTimeRangeAlert
			})
			sensorAlerts = sortBy(sensorAlerts, 'alertDate')
			sensorAlerts = sortBy(sensorAlerts, 'alert')
			sensorAlerts.reverse()
			return sensorAlerts
		} catch (error: any) {
			console.log(error)
			return {}
		}
	},

	alertsForCg: (s: any, g: any) => {
		const result: any = {}
		const alerts = s.alerts || {}
		const warns = s.warns || {}
		const customGraphsObj = g.customGraphsObj || {}
		for (const cgId in alerts) {
			for (const eq of customGraphsObj?.[cgId]?.equations || []) {
				const skey = `-/-/${eq.name}`
				const isAlert = !!alerts[cgId]?.data?.[skey]
				const isWarn = !!warns[cgId]?.data?.[skey]
				if (result[`${cgId}`] === 'alert') {
				} else if (isAlert) result[`${cgId}`] = 'alert'
				else if (isWarn) result[`${cgId}`] = 'warn'
			}
		}
		return result
	},

	//?invetory
	invClassList: (s: any, g: any) => {
		return s.inventoryMeta.class
	},
	invStatusList: (s: any, g: any) => {
		return s.inventoryMeta.status
	},
	invStorageList: (s: any, g: any) => {
		return s.inventoryMeta.storageLocation
	},

	// invManufaturerList: (s: any, g: any) => { return s.inventoryMeta.company.filter((e: any) => ['manufacturer', 'both'].includes(e.type)) },
	invManufaturerList: (s: any, g: any) => {
		const asArray = Object.entries(g.invCompanyList || {})
		const filtered = asArray.filter(([key, value]: any) => ['manufacturer', 'both'].includes(value.type))
		return Object.fromEntries(filtered)
	},
	invSupplierList: (s: any, g: any) => {
		const asArray = Object.entries(g.invCompanyList || {})
		const filtered = asArray.filter(([key, value]: any) => ['supplier', 'both'].includes(value.type))
		return Object.fromEntries(filtered)
	},

	invCompanyList: (s: any, g: any) => {
		return s.inventoryMeta.company
	},
}

export default getters
